import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FlyingPigSVG } from "./FlyingPig";

/**
 * Scroll-driven flying pigs. Pigs float across the viewport as the user scrolls.
 * They live in a fixed-position layer with pointer-events disabled so they never block UI.
 */
export default function FlyingPigs() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll();

  // Pig 1 — left → right, top band
  const x1 = useTransform(scrollYProgress, [0, 1], ["-15vw", "115vw"]);
  const y1 = useTransform(scrollYProgress, [0, 0.5, 1], ["10vh", "22vh", "8vh"]);
  const r1 = useTransform(scrollYProgress, [0, 1], [-6, 8]);

  // Pig 2 — right → left, middle band
  const x2 = useTransform(scrollYProgress, [0, 1], ["120vw", "-25vw"]);
  const y2 = useTransform(scrollYProgress, [0, 0.5, 1], ["55vh", "40vh", "62vh"]);
  const r2 = useTransform(scrollYProgress, [0, 1], [10, -12]);

  // Pig 3 — small, bottom band, left → right
  const x3 = useTransform(scrollYProgress, [0, 1], ["-20vw", "125vw"]);
  const y3 = useTransform(scrollYProgress, [0, 0.5, 1], ["78vh", "70vh", "82vh"]);
  const r3 = useTransform(scrollYProgress, [0, 1], [-14, 6]);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-30 overflow-hidden"
      data-testid="flying-pigs-layer"
    >
      <motion.div style={{ x: x1, y: y1, rotate: r1 }} className="absolute">
        <FlyingPigSVG className="w-24 md:w-36 opacity-80 drop-shadow-[3px_3px_0_rgba(15,15,15,0.15)]" />
      </motion.div>

      <motion.div style={{ x: x2, y: y2, rotate: r2, scaleX: -1 }} className="absolute">
        <FlyingPigSVG className="w-20 md:w-28 opacity-50" />
      </motion.div>

      <motion.div style={{ x: x3, y: y3, rotate: r3 }} className="absolute">
        <FlyingPigSVG className="w-14 md:w-20 opacity-40" />
      </motion.div>
    </div>
  );
}
